/**
 * @generated SignedSource<<861d68f2178f3e9751e1af360f5f88b3>>
 * @relayHash 9eaef2a34ca96ab2ac994463c9f14cdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95

import type { ConcreteRequest } from 'relay-runtime';
export type useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery$variables = Record<PropertyKey, never>;
export type useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery = {
  response: useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery$data;
  variables: useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v0/*: any*/)
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9eaef2a34ca96ab2ac994463c9f14cdb",
    "id": "ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95",
    "metadata": {},
    "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
    "operationKind": "query",
    "text": "query useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{key,id}}}}"
  }
};
})();

(node as any).hash = "6fe5c1685a204de18171323aa7dc40fa";

export default node;
